// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2Y9Lo","select":"Header_select__3StID","clinic":"Header_clinic__1zFXN"};